import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_TextfieldTag, {
        placeholder: "件名",
        style: {"height":"50px","padding":"0 20px"},
        class: "fl fs14 roundForm mw100 rad20 mt20",
        value: _ctx.currentMailSubject,
        onInputValue: _ctx.inputSubject
      }, null, 8, ["value", "onInputValue"]),
      _hoisted_2,
      _createVNode(_component_TextareaTag, {
        placeholder: "先日はメールいただきましてありがとうございます。",
        class: "fl fs14 roundForm mw100 rad20 llgreyBg mt20",
        style: `height:300px;padding:20px;`,
        value: _ctx.currentMailContent,
        onInputValue: _ctx.inputContent
      }, null, 8, ["value", "onInputValue"]),
      _hoisted_3
    ]),
    _hoisted_4
  ]))
}